const ShowLoading = (param) => {
  return async (dispatch) => {
      dispatch({
          type:'ShowLoading',
          data: {loading: true}
      })
  }
}
const HideLoading = (param) => {
  return async (dispatch) => {
      dispatch({
          type:'HideLoading',
          data: {loading: false}
      })
  }
}
export { ShowLoading, HideLoading };